export default __webpack_public_path__ + "static/media/community-licence-scan.2ce6d256.png";